import * as React from 'react';

const Goodiebag = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={39} height={42} fill="none" viewBox="0 0 39 42" {...props}>
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M31.378 12.635H8.053a2.32 2.32 0 0 0-1.546.508c-.436.35-.73.847-.827 1.398L2.374 37.463a2.23 2.23 0 0 0 .659 1.707 2.24 2.24 0 0 0 1.716.646h29.933a2.25 2.25 0 0 0 2.227-1.43c.114-.293.163-.608.146-.923l-3.306-22.922a2.3 2.3 0 0 0-.826-1.397 2.32 2.32 0 0 0-1.545-.51M25.808 7.008c-.272-1.316-1.03-2.503-2.142-3.358a6.54 6.54 0 0 0-3.96-1.33 6.54 6.54 0 0 0-3.94 1.323c-1.11.849-1.868 2.028-2.145 3.336"
        />
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="m24.402 22.476-5.83 7.5-3.545-3.42"
        />
    </svg>
);
export default Goodiebag;
